import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, InvestmentsLiquidationPending, Text, useResponsive } from '@common-fe/common-fe';

import { Banner } from '@/modules/core/components/Dashboard/components/BannersList/Banner';
const InvestmentLiquidationPendingBanner = () => {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();
  return (
    <Box
      direction="column"
      pad={isMobile ? 'spacing16' : 'spacing24'}
      background="border1"
      round="moduleRound"
      data-testid="investment-pending"
    >
      <Banner
        isWideMode
        title={t('Your Full Portfolio Liquidation Is In Progress')}
        description={
          <>
            <Text size="medium">
              {t('Once the sell orders are settled, you will no longer have active investments.')}
            </Text>
            <Text size="medium">{t('You can start investing again when ready.')}</Text>
          </>
        }
        icon={<InvestmentsLiquidationPending />}
        testId="investment-pending"
      />
    </Box>
  );
};

export default InvestmentLiquidationPendingBanner;
